import React from 'react'

import { ValidatorForm } from 'react-material-ui-form-validator'

import {
    GridContainer,
    GridItem8sm12xs12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    FormatoReportRadioGroup
} from '../../../business-rules/RadioGroup/FormatoReportRadioGroup'



const EstudoReportFormatoReport = ( { values, handleChange, handleSubmit } ) => {

    return (
        <ValidatorForm 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <GridContainer
                className="justify-center"
            >
                <GridItem8sm12xs12>
                    <CardGridEntradaDados>
                        <CardGridDivBodyEntradaDados>
                            <FormatoReportRadioGroup
                                className="justify-center"
                                name="formatoReport"
                                value={values.formatoReport || ''}
                                onChange={handleChange}
                                values={values}
                            />
                        </CardGridDivBodyEntradaDados>
                    </CardGridEntradaDados>
                </GridItem8sm12xs12>
            </GridContainer>
        </ValidatorForm>
    )
}

export default EstudoReportFormatoReport